import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Redirect, useHistory } from "react-router-dom";
import MyLoader from "../Spinner/MyLoader";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import SelectClass from "../ChildComponent/SelectClass";
import BackButton from "../ChildComponent/BackButton";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const PANEL_STYLE = {
  margin: "0 20px 20px",
  padding: "0",
};

const PAGE_TITLE_BAR_STYLE = {
  width: "100%",
  background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade8} 100%)`,
  padding: "16px 24px",
  borderRadius: "8px 8px 0 0",
  boxShadow: `0 2px 4px ${COLORS.primary_color_shade3}`,
  marginTop: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "10px",
};

const PAGE_TITLE_STYLE = {
  fontSize: "24px",
  fontWeight: "600",
  color: "#fff",
  margin: 0,
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const PANEL_BODY_STYLE = {
  padding: "20px 24px 30px",
  background: COLORS.white,
};

const STYLES = {
  countBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "32px",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: "800",
    color: COLORS.primary_color_shade8,
    background: "rgba(255, 255, 255, 0.92)",
    border: "2px solid rgba(255, 255, 255, 0.65)",
    boxShadow: "0 1px 4px rgba(1, 87, 155, 0.2)",
  },
  addBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    border: "none",
    borderRadius: "8px",
    padding: "10px 18px",
    fontSize: "13px",
    fontWeight: "800",
    color: COLORS.white,
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`,
    boxShadow: `0 3px 8px ${COLORS.primary_color_shade4}55`,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  tableWrap: {
    width: "100%",
    overflowX: "auto",
    borderRadius: "12px",
    border: `1px solid ${COLORS.primary_color_shade3}`,
    boxShadow: `0 4px 16px ${COLORS.primary_color_shade2}55`,
    background: COLORS.white,
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    margin: 0,
    background: COLORS.white,
    minWidth: "920px",
  },
  th: {
    padding: "13px 14px",
    fontSize: "11px",
    fontWeight: "800",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    color: COLORS.primary_color_shade9,
    background: COLORS.primary_color_shade1,
    borderBottom: `2px solid ${COLORS.primary_color_shade3}`,
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  td: {
    padding: "12px 14px",
    fontSize: "13px",
    fontWeight: "600",
    color: COLORS.primary_color_shade9,
    borderBottom: `1px solid ${COLORS.primary_color_shade2}`,
    verticalAlign: "middle",
  },
  indexChip: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "28px",
    height: "28px",
    padding: "0 6px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "800",
    color: COLORS.primary_color_shade8,
    background: COLORS.primary_color_shade1,
    border: `1px solid ${COLORS.primary_color_shade3}`,
  },
  studentCell: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0,
  },
  avatar: {
    width: "42px",
    height: "42px",
    borderRadius: "50%",
    objectFit: "cover",
    border: `2px solid ${COLORS.primary_color_shade3}`,
    flexShrink: 0,
    background: COLORS.white,
    boxShadow: `0 2px 6px ${COLORS.primary_color_shade3}66`,
  },
  avatarFallback: {
    width: "42px",
    height: "42px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade2} 0%, ${COLORS.primary_color_shade4} 100%)`,
    color: COLORS.white,
    flexShrink: 0,
    border: `2px solid ${COLORS.primary_color_shade3}`,
    fontSize: "15px",
    boxShadow: `0 2px 6px ${COLORS.primary_color_shade3}66`,
  },
  studentName: {
    margin: 0,
    fontSize: "13px",
    fontWeight: "800",
    color: COLORS.primary_color_shade9,
    lineHeight: "1.3",
  },
  studentSub: {
    margin: "2px 0 0",
    fontSize: "11px",
    fontWeight: "600",
    color: COLORS.primary_color_shade6,
    lineHeight: "1.3",
  },
  classChip: {
    display: "inline-flex",
    alignItems: "center",
    maxWidth: "160px",
    padding: "5px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: "700",
    color: COLORS.primary_color_shade8,
    background: COLORS.primary_color_shade1,
    border: `1px solid ${COLORS.primary_color_shade3}`,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  certBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "5px 10px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "800",
    color: COLORS.primary_color_shade9,
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade0} 0%, ${COLORS.primary_color_shade1} 100%)`,
    border: `1px solid ${COLORS.primary_color_shade3}`,
    letterSpacing: "0.02em",
  },
  dateText: {
    margin: 0,
    fontSize: "12px",
    fontWeight: "700",
    color: COLORS.primary_color_shade8,
    whiteSpace: "nowrap",
  },
  actionsCell: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    flexWrap: "nowrap",
  },
  primaryAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    border: "none",
    borderRadius: "8px",
    padding: "7px 12px",
    fontSize: "11px",
    fontWeight: "800",
    color: COLORS.white,
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`,
    cursor: "pointer",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
    boxShadow: `0 2px 6px ${COLORS.primary_color_shade4}55`,
  },
  editAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    border: `1.5px solid ${COLORS.primary_color_shade5}`,
    borderRadius: "8px",
    padding: "6px 12px",
    fontSize: "11px",
    fontWeight: "800",
    color: COLORS.primary_color_shade7,
    background: COLORS.white,
    cursor: "pointer",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
  },
  dangerAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    border: `1.5px solid ${COLORS.card_red}`,
    borderRadius: "8px",
    padding: "6px 12px",
    fontSize: "11px",
    fontWeight: "800",
    color: COLORS.card_red,
    background: COLORS.white,
    cursor: "pointer",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap",
  },
};

//Created By Cursor
function normalizePhotoUrl(path) {
  const value = String(path || "").trim();
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  const base = String(process.env.REACT_APP_SERVER_NAME || "").replace(/\/$/, "");
  return `${base}/${value.replace(/^\//, "")}`;
}

//Created By Cursor — show dates consistently as dd-MM-yyyy
function formatDisplayDate(value) {
  const raw = String(value || "").trim();
  if (!raw || raw === "0000-00-00") return "-";
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
    const [y, m, d] = raw.slice(0, 10).split("-");
    return `${d}-${m}-${y}`;
  }
  const match = raw.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
  if (match) {
    return `${match[1].padStart(2, "0")}-${match[2].padStart(2, "0")}-${match[3]}`;
  }
  return raw;
}

function PageHeader({ onBack }) {
  return (
    <div
      className="content-header"
      style={{ background: COLORS.primary_color_shade5 }}
    >
      <div className="leftside-content-header">
        <ul className="breadcrumbs">
          <li>
            <i
              className="fa fa-home"
              aria-hidden="true"
              style={{ color: COLORS.white }}
            />
            <span style={{ color: COLORS.white }}>Transfer Certificate</span>
          </li>
        </ul>
      </div>
      <div className="rightside-content-header">
        <BackButton onClick={onBack} />
      </div>
    </div>
  );
}

const StudentRow = memo(
  ({ student, index, busyKey, onGetCertificate, onEdit, onDelete }) => {
    const [imageError, setImageError] = useState(false);
    const studentName = student.stu_name || student.name || "Student";
    const className = student.passed_class_name || student.class_name || "-";
    const photoUrl = normalizePhotoUrl(
      student.student_img_path || student.photo_url
    );
    const rowKey = `${student.student_id || ""}-${student.certificate_no || ""}`;
    const busy = busyKey === rowKey;
    const zebra = index % 2 === 0 ? COLORS.white : "rgba(227, 242, 253, 0.4)";

    return (
      <tr
        onMouseEnter={(e) => {
          e.currentTarget.style.background = COLORS.primary_color_shade1;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = zebra;
        }}
        style={{ background: zebra }}
      >
        <td style={{ ...STYLES.td, width: 56, textAlign: "center" }}>
          <span style={STYLES.indexChip}>{index + 1}</span>
        </td>
        <td style={STYLES.td}>
          <div style={STYLES.studentCell}>
            {!imageError && photoUrl ? (
              <img
                src={photoUrl}
                alt={studentName}
                style={STYLES.avatar}
                onError={() => setImageError(true)}
              />
            ) : (
              <div style={STYLES.avatarFallback}>
                <i className="fa fa-user" aria-hidden="true" />
              </div>
            )}
            <div style={{ minWidth: 0 }}>
              <p style={STYLES.studentName}>{studentName}</p>
              <p style={STYLES.studentSub}>
                ID: {student.student_id || "-"}
              </p>
            </div>
          </div>
        </td>
        <td style={STYLES.td}>{student.father_name || "-"}</td>
        <td style={STYLES.td}>
          <span style={STYLES.classChip} title={className}>
            {className}
          </span>
        </td>
        <td style={STYLES.td}>
          <span style={STYLES.certBadge}>
            <i className="fa fa-hashtag" aria-hidden="true" />
            {student.certificate_no || "-"}
          </span>
        </td>
        <td style={STYLES.td}>
          <p style={STYLES.dateText}>
            {formatDisplayDate(student.leaving_date)}
          </p>
        </td>
        <td style={STYLES.td}>
          <div style={STYLES.actionsCell}>
            <button
              type="button"
              style={{
                ...STYLES.primaryAction,
                opacity: busy ? 0.7 : 1,
                cursor: busy ? "wait" : "pointer",
              }}
              disabled={busy}
              onClick={() => onGetCertificate(student)}
              title="Get Certificate"
            >
              <i className="fa fa-file-text-o" aria-hidden="true" />
              {busy ? "…" : "View"}
            </button>
            <button
              type="button"
              style={{
                ...STYLES.editAction,
                opacity: busy ? 0.7 : 1,
                cursor: busy ? "wait" : "pointer",
              }}
              disabled={busy}
              onClick={() => onEdit(student)}
              title="Edit Certificate"
            >
              <i className="fa fa-pencil" aria-hidden="true" />
              Edit
            </button>
            <button
              type="button"
              style={{
                ...STYLES.dangerAction,
                opacity: busy ? 0.7 : 1,
                cursor: busy ? "wait" : "pointer",
              }}
              disabled={busy}
              onClick={() => onDelete(student)}
              title="Delete Certificate"
            >
              <i className="fa fa-trash-o" aria-hidden="true" />
              Delete
            </button>
          </div>
        </td>
      </tr>
    );
  }
);

StudentRow.displayName = "StudentRow";

const TransferCertificatePage = memo(
  ({
    students,
    selectedClassPosition,
    loadingList,
    busyKey,
    onClassSelect,
    onAddStudent,
    onGetCertificate,
    onEditStudent,
    onDeleteStudent,
    onBack,
  }) => (
    <div className="content" style={{ background: COLORS.white }}>
      <PageHeader onBack={onBack} />

      <div
        className="animated fadeInUp bg_page_white_rounded box_shadow"
        style={PANEL_STYLE}
      >
        <div style={PAGE_TITLE_BAR_STYLE}>
          <h3 style={PAGE_TITLE_STYLE}>
            <i
              className="fa fa-file-text-o"
              aria-hidden="true"
              style={{ color: "#fff" }}
            />
            Transfer Certificate
          </h3>
          <span style={STYLES.countBadge}>{students.length}</span>
        </div>

        <div style={PANEL_BODY_STYLE}>
          <SelectClass
            action={onClassSelect}
            selected_position={selectedClassPosition}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "16px 0",
            }}
          >
            <button type="button" style={STYLES.addBtn} onClick={onAddStudent}>
              <i className="fa fa-plus" aria-hidden="true" />
              Add New Leaving Student
            </button>
          </div>

          {loadingList ? (
            <MyLoader />
          ) : students.length > 0 ? (
            <div style={STYLES.tableWrap}>
              <table style={STYLES.table}>
                <thead>
                  <tr>
                    <th style={{ ...STYLES.th, width: 56, textAlign: "center" }}>
                      #
                    </th>
                    <th style={STYLES.th}>Student</th>
                    <th style={STYLES.th}>Father</th>
                    <th style={STYLES.th}>Class</th>
                    <th style={STYLES.th}>Cert. No</th>
                    <th style={STYLES.th}>Leaving</th>
                    <th style={{ ...STYLES.th, minWidth: 220 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student, index) => (
                    <StudentRow
                      key={`${student.student_id || "stu"}-${
                        student.certificate_no || index
                      }`}
                      student={student}
                      index={index}
                      busyKey={busyKey}
                      onGetCertificate={onGetCertificate}
                      onEdit={onEditStudent}
                      onDelete={onDeleteStudent}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-5">
              <div
                style={{
                  width: "72px",
                  height: "72px",
                  margin: "0 auto 16px",
                  borderRadius: "50%",
                  background: `linear-gradient(135deg, ${COLORS.primary_color_shade2} 0%, ${COLORS.primary_color_shade4} 100%)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}55`,
                }}
              >
                <i
                  className="fa fa-file-text-o"
                  style={{ fontSize: "28px", color: COLORS.white }}
                  aria-hidden="true"
                />
              </div>
              <h5
                style={{ color: COLORS.primary_color_shade8, fontWeight: "700" }}
              >
                No Leaving Students Found
              </h5>
              <p style={{ color: COLORS.primary_color_shade6, marginBottom: 0 }}>
                Add a new leaving student or change the selected class.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
);

TransferCertificatePage.displayName = "TransferCertificatePage";

const TransferCertificate = () => {
  const history = useHistory();
  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingList, setLoadingList] = useState(false);
  const [busyKey, setBusyKey] = useState("");
  const [students, setStudents] = useState([]);
  const [sessionId, setSessionId] = useState(
    () => SessionManager.getCurrentSession()?.[0]?.session_id || ""
  );
  const [classId, setClassId] = useState("");
  const [className, setClassName] = useState("");
  const [selectedClassPosition, setSelectedClassPosition] = useState("0");

  const handleBack = useCallback(() => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      history.push("/AdminMain");
    }
  }, [history]);

  //Created By Cursor
  const fetchLeavingStudents = useCallback(async (activeSessionId) => {
    const resolvedSessionId =
      activeSessionId ||
      SessionManager.getCurrentSession()?.[0]?.session_id ||
      "";

    if (!resolvedSessionId) {
      setStudents([]);
      setInitialLoading(false);
      setLoadingList(false);
      myToast.notify_warning("No active session found.");
      return;
    }

    try {
      setLoadingList(true);
      const response = await axios.get(`${API_BASE()}getLeavingStudentList.php`, {
        params: {
          school_code: SessionManager.getSchoolCode(),
          session_id: resolvedSessionId,
        },
      });

      if (response.data?.api_status === "OK") {
        setStudents(
          Array.isArray(response.data.data) ? response.data.data : []
        );
      } else {
        // Treat "no record" as empty list (legacy API wording)
        const remark = String(response.data?.api_remark || "").toLowerCase();
        if (remark.includes("no record") || remark.includes("not found")) {
          setStudents([]);
        } else {
          setStudents([]);
          myToast.notify_warning(
            response.data?.api_remark || "Failed to load leaving students."
          );
        }
      }
    } catch (error) {
      setStudents([]);
      const errorMessage =
        error.response?.data?.api_remark ||
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch leaving student list";
      console.error("Error fetching TC data:", error);
      myToast.notify_error(errorMessage);
    } finally {
      setInitialLoading(false);
      setLoadingList(false);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchLeavingStudents(sessionId);
  }, [fetchLeavingStudents, sessionId]);

  //Created By Cursor — always refresh list on SelectClass change (session or class)
  const handleClassSelect = useCallback(
    (
      class_id,
      _section_id,
      session_id,
      selected_position,
      class_name
    ) => {
      const nextSessionId =
        session_id ||
        SessionManager.getCurrentSession()?.[0]?.session_id ||
        "";
      const nextClassId =
        class_id && class_id !== "All" ? String(class_id) : "";
      const nextClassName = String(class_name || "").trim();

      setClassId(nextClassId);
      setClassName(nextClassName);
      setSelectedClassPosition(String(selected_position ?? "0"));

      if (!nextSessionId) {
        return;
      }

      // Session changed → update state (useEffect also fetches); same session → fetch now
      if (nextSessionId !== sessionId) {
        setStudents([]);
        setSessionId(nextSessionId);
      } else {
        fetchLeavingStudents(nextSessionId);
      }
    },
    [sessionId, fetchLeavingStudents]
  );

  const filteredStudents = useMemo(() => {
    if (!classId) {
      return students;
    }
    const classIdStr = String(classId);
    const classNameLower = String(className || "")
      .trim()
      .toLowerCase();

    return students.filter((student) => {
      const passedId = String(student.passed_class_id || "");
      const altId = String(student.class_id || "");
      if (passedId === classIdStr || altId === classIdStr) {
        return true;
      }
      // Fallback: match class name when ids differ across sessions/boards
      if (!classNameLower) {
        return false;
      }
      const passedName = String(student.passed_class_name || "")
        .trim()
        .toLowerCase();
      if (!passedName) {
        return false;
      }
      return (
        passedName === classNameLower ||
        passedName.startsWith(`${classNameLower}:`) ||
        passedName.startsWith(`${classNameLower} `)
      );
    });
  }, [students, classId, className]);

  const handleAddStudent = useCallback(() => {
    history.push("/AdminMain/TransferCertificateForm");
  }, [history]);

  //Created By Cursor — open TC preview page (iframe) instead of popup
  const handleGetCertificate = useCallback(
    (student) => {
      const studentId = student?.student_id;
      if (!studentId) {
        myToast.notify_warning("Student id missing for this certificate.");
        return;
      }
      history.push({
        pathname: "/AdminMain/TransferCertificatePreview",
        state: { student },
      });
    },
    [history]
  );

  //Created By Cursor — edit existing leaving certificate
  const handleEditStudent = useCallback(
    (student) => {
      const studentId = student?.student_id;
      const certificateNo = student?.certificate_no;
      if (!studentId || !certificateNo) {
        myToast.notify_warning("Certificate details are incomplete.");
        return;
      }
      history.push({
        pathname: "/AdminMain/TransferCertificateForm",
        state: { mode: "edit", certificate: student },
      });
    },
    [history]
  );

  //Created By Cursor
  const handleDeleteStudent = useCallback(
    async (student) => {
      const studentId = String(student?.student_id || "").trim();
      const certificateNo = String(student?.certificate_no || "").trim();
      const sid = String(
        student?.session_id ||
          sessionId ||
          SessionManager.getCurrentSession()?.[0]?.session_id ||
          ""
      ).trim();
      const staffId = String(
        SessionManager.getStaffDetails()?.staff_id || ""
      ).trim();
      const schoolCode = String(SessionManager.getSchoolCode() || "").trim();

      if (!studentId || !certificateNo || !sid) {
        myToast.notify_warning("Certificate details are incomplete.");
        return;
      }
      if (!staffId) {
        myToast.notify_warning("Staff session required to delete.");
        return;
      }
      if (!schoolCode) {
        myToast.notify_warning("School code missing.");
        return;
      }
      if (
        !window.confirm(
          `Delete leaving certificate ${certificateNo} for ${
            student.stu_name || "this student"
          }?`
        )
      ) {
        return;
      }

      const key = `${studentId}-${certificateNo}`;
      setBusyKey(key);
      try {
        const res = await axios.get(`${API_BASE()}deleteLeavingCertificate.php`, {
          params: {
            staff_id: staffId,
            session_id: sid,
            student_id: studentId,
            certificate_no: certificateNo,
            school_code: schoolCode,
          },
        });

        let payload = res.data;
        if (typeof payload === "string") {
          try {
            payload = JSON.parse(payload);
          } catch (e) {
            payload = null;
          }
        }

        if (payload?.api_status === "OK") {
          myToast.notify_success("Leaving certificate deleted.");
          setStudents((prev) =>
            prev.filter(
              (row) =>
                !(
                  String(row.student_id) === String(studentId) &&
                  String(row.certificate_no) === String(certificateNo)
                )
            )
          );
        } else {
          myToast.notify_warning(
            payload?.api_remark || "Failed to delete certificate."
          );
        }
      } catch (error) {
        console.error(error);
        myToast.notify_error(
          error.response?.data?.api_remark ||
            error.message ||
            "Failed to delete leaving certificate."
        );
      } finally {
        setBusyKey("");
      }
    },
    [sessionId]
  );

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (initialLoading && students.length === 0 && loadingList) {
    return <MyLoader />;
  }

  return (
    <TransferCertificatePage
      students={filteredStudents}
      selectedClassPosition={selectedClassPosition}
      loadingList={loadingList}
      busyKey={busyKey}
      onClassSelect={handleClassSelect}
      onAddStudent={handleAddStudent}
      onGetCertificate={handleGetCertificate}
      onEditStudent={handleEditStudent}
      onDeleteStudent={handleDeleteStudent}
      onBack={handleBack}
    />
  );
};

TransferCertificate.displayName = "TransferCertificate";

export default memo(TransferCertificate);
